// Programmatically opened Bootstrap modals need explicit focus restoration.
export function manageModalFocus(element) {
  let opener = null;
  const rememberFocus = () => {
    opener = document.activeElement;
  };
  const releaseFocus = () => {
    const focused = document.activeElement;
    if (element.contains(focused) && typeof focused.blur === 'function') {
      focused.blur();
    }
  };
  const restoreFocus = () => {
    if (opener?.isConnected && !element.contains(opener)) {
      opener.focus({ preventScroll: true });
    }
    opener = null;
  };

  element.addEventListener('show.bs.modal', rememberFocus);
  element.addEventListener('hide.bs.modal', releaseFocus);
  element.addEventListener('hidden.bs.modal', restoreFocus);

  return () => {
    element.removeEventListener('show.bs.modal', rememberFocus);
    element.removeEventListener('hide.bs.modal', releaseFocus);
    element.removeEventListener('hidden.bs.modal', restoreFocus);
    opener = null;
  };
}
